import { useSelector } from 'react-redux';
import { evaluatedPolicySelectors } from '../redux/modules/evaluatedPolicy';
import * as abac from '@lifeomic/abac';

export const usePolicy = (): abac.AbacReducedPolicy =>
  useSelector(evaluatedPolicySelectors.selectPolicyForUser);

export default usePolicy;
